import axios from "axios";

export default axios.create({
  baseURL:
    window.location.origin +
    window.location.pathname
      .split("/")
      .slice(0, 3)
      .join("/")
});
